<template>
  <div>
    <form id="form" @submit.prevent="sendEdit">
      <img
        @click="closeModal()"
        src="@/assets/img/icons/close-icon.png"
        alt="close-icon"
        class="icon-close"
      />
      <h1 style="text-align:center">{{ $t("attendees.edit") }}</h1>
      <hr />
      <div id="inputContainer">
        <b-field class="labelInput" :label="$t('attendees.firstName') + '*'"
          ><input
            type="text"
            id="prenom"
            class="input"
            v-model="edited.first_name"
        /></b-field>
        <b-field class="labelInput" :label="$t('attendees.lastName') + '*'"
          ><input type="text" id="nom" class="input" v-model="edited.last_name"
        /></b-field>
        <b-field class="labelInput" :label="$t('attendees.email')"
          ><input
            type="text"
            @change="validate"
            @input="validate"
            @hover="validate"
            @focus="validate"
            @click="validate"
            id="email"
            class="input"
            v-model="edited.email"
        /></b-field>
        <b-field class="labelInput" :label="$t('attendees.company')"
          ><input
            type="text"
            id="company"
            class="input"
            v-model="edited.company"
        /></b-field>
      </div>
      <div id="switchContainer">
        <b-field class="flexSwitch" :label="$t('attendees.present')">
          <b-switch
            ref="present"
            type="is-success"
            v-model="edited.present"
            :true-value="1"
            :false-value="0"
            :native-value="!!edited.present"
          >
          </b-switch>
        </b-field>
        <b-field class="flexSwitch" :label="$t('attendees.agrees')">
          <b-switch
            ref="accepts_terms_conditions"
            type="is-success"
            v-model="edited.accepts_terms_conditions"
            :true-value="1"
            :false-value="0"
            :native-value="!!edited.accepts_terms_conditions"
          >
          </b-switch>
        </b-field>
        <div class="flexSwitch">
          <button
            class="button is-primary"
            id="resetButton"
            @click="
              e => {
                resetValues(e);
              }
            "
          >
            Remettre les choix à zéro
          </button>
        </div>
      </div>
      <button
        style="margin: 0px auto;width: auto;"
        :disabled="
          !validEmail || edited.lastName === '' || edited.firstName === ''
        "
        class="button is-primary"
      >
        {{ $t("attendees.confirmEdit") }}
      </button>
      <div id="fillItAll">{{ $t("popup.required") }}</div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EditAdmin",
  data() {
    return {
      validEmail: undefined,
      edited: {},
      prenom: this.row.first_name,
      nom: this.row.last_name,
      email: this.row.email,
      company: this.row.company
    };
  },
  props: ["row", "allRows"],
  created() {
    this.edited.first_name = this.row.first_name;
    this.edited.last_name = this.row.last_name;
    this.edited.email = this.row.email || "";
    this.edited.company = this.row.company || "";
    this.edited.event_id = this.row.event_id;
    this.edited.present = this.row.present;
    this.edited.accepts_terms_conditions = this.row.accepts_terms_conditions;
    this.edited.id = this.row.id;
    this.validate();
  },
  watch: {
    edited: {
      deep: true,
      handler: function() {
        if (this.edited.email) {
          this.edited.email = this.edited.email.replace(/\s/g, "");
          var regEmail = /^[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}(\;[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}){0,20}$/;

          if (regEmail.test(String(this.edited.email).toLowerCase())) {
            this.validEmail = true;
          } else {
            this.validEmail = false;
          }
        }
      }
    }
  },
  computed: {
    checkCorrectForm() {
      this.validate();
      if (
        this.validEmail ||
        this.edited.email == null ||
        this.edited.email == ""
      ) {
        if (this.edited.firstName !== null && this.edited.firstName !== "") {
          if (this.edited.lastName !== null && this.edited.lastName !== "") {
            return false;
          }
        }
      }
      return true;
    }
  },
  methods: {
    closeModal() {
      this.$parent.close();
    },
    resetValues(e) {
      e.preventDefault();
      this.edited.present = false;
      this.edited.accepts_terms_conditions = null;
      this.$refs.present.value = false;
      this.$refs.accepts_terms_conditions.value = false;
    },
    validate() {
      this.edited.email = this.edited.email.replace(/\s/g, "");
      var regEmail = /^[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}(\;[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}){0,20}$/;

      if (
        regEmail.test(String(this.edited.email).toLowerCase()) ||
        this.edited.email === ""
      ) {
        this.validEmail = true;
      } else {
        this.validEmail = false;
      }
    },
    sendEdit(props) {
      let regMail = /^[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,6}(\;[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,6}){0,4}$/;
      if (regMail.test(this.edited.email) || this.edited.email === "") {
        axios
          .put(`${process.env.URL_SSO_API}shortcut/attendees`, this.edited, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$parent.$i18n.t("toast.editSuccess")
            });
          })

          .catch(err => {
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$parent.$i18n.t("toast.updateError")
            });
          });
      }

      this.$parent.$parent.search("");
      this.$parent.close();
    }
  }
};
</script>

<style scoped>
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: auto;
}
#resetButton {
  background: #dddddd;
  color: black;
  width: max-content;
  margin: 5px;
}

* {
  width: 100%;
}
h1 {
  font-size: 16px;
}
#form {
  padding: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  min-width: 200px;
  min-height: 200px;
  background-color: white;
}

.labelInput :not(:last-child) {
  margin-right: 10px;
  font-size: 12px;
}

#inputContainer {
  display: flex;
  flex-direction: column;
  padding: 10px;
  justify-content: space-between;
}

#switchContainer {
  display: flex;
  padding: 10px;
}
.flexSwitch {
  font-size: 12px;
  margin: 10px 0px;
  width: 200px;
}
/* .labelSwitch {
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-items: center;
  justify-content: center;
  align-self: center;
  align-content: center;
  align-items: center;
}

.labelSwitch label {
  margin: 10px;
}

.labelSwitch .switch * {
  margin: auto;
} */
</style>



// WEBPACK FOOTER //
// src/components/popup/popupEditAdmin.vue